import { useState } from "react";
import { NavLink } from "react-router-dom";
import Icons from "../assest/icon.png";
import CityModal from "../utils/selectcitymodal";
import BookMeetingModal from "../utils/bookingmodal";
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState("Select City");
  const [openModal, setOpenModal] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full h-[80px] bg-white border-b border-[#eee] z-50">

      {/* ================= MOBILE TOP BAR ================= */}
      <div className="flex md:hidden items-center justify-between h-full px-[12px]">

        {/* MENU */}
        <div
          className="flex items-center justify-center w-[36px] h-[36px] rounded-md hover:bg-gray-100 active:scale-95 transition"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className="flex flex-col">
            <span className="w-[20px] h-[2px] bg-[#333] my-[2px]"></span>
            <span className="w-[20px] h-[2px] bg-[#333] my-[2px]"></span>
            <span className="w-[20px] h-[2px] bg-[#333] my-[2px]"></span>
          </div>
        </div>

        {/* LOGO */}
        <div className="flex-1 flex justify-center">
          <img src={Icons} alt="logo" className="w-[34px]" />
        </div>

        {/* RIGHT */}
        <div className="flex items-center gap-[6px]">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center text-[11px] gap-1 h-[30px] px-[8px] text-[#6c4ccf]"
          >
            {selectedCity} ❯
          </button>

          <button className="h-[30px] px-[10px] text-[11px] border border-[#6c4ccf] text-[#6c4ccf] rounded-md hover:bg-[#6c4ccf] hover:text-white transition">
            Login
          </button>
        </div>
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="hidden md:flex items-center justify-between h-full px-[60px]">

        {/* LOGO */}
        <div>
          <img src={Icons} alt="logo" className="w-[35px]" />
        </div>

        {/* NAV LINKS */}
        <nav className="flex items-center font-poppins gap-[28px]">

          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "text-[#6c4ccf] font-medium"
                : "text-[#2e2e2e] hover:text-[#6c4ccf]"
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/Ourproject"
            className={({ isActive }) =>
              isActive
                ? "text-[#6c4ccf] font-medium"
                : "text-[#2e2e2e] hover:text-[#6c4ccf]"
            }
          >
            Our projects
          </NavLink>

          <NavLink
            to="/HappyCustomers"
            className={({ isActive }) =>
              isActive
                ? "text-[#6c4ccf] font-medium"
                : "text-[#2e2e2e] hover:text-[#6c4ccf]"
            }
          >
            Testimonials
          </NavLink>

          <NavLink
            to="/CostEstimator"
            className={({ isActive }) =>
              isActive
                ? "text-[#6c4ccf] font-medium"
                : "text-[#2e2e2e] hover:text-[#6c4ccf]"
            }
          >
            Cost estimator
          </NavLink>

          <NavLink
            to="/Contact"
            className={({ isActive }) =>
              isActive
                ? "text-[#6c4ccf] font-medium"
                : "text-[#2e2e2e] hover:text-[#6c4ccf]"
            }
          >
            Contacts
          </NavLink>

        </nav>

        {/* RIGHT */}
        <div className="flex items-center gap-[15px]">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-1 h-[30px] px-[8px] text-[#6c4ccf] font-poppins"
          >
            {selectedCity} ❯
          </button>

          <button className="h-[38px] px-[24px]  font-poppins rounded-[10px] border border-[#6c4ccf] text-[#6c4ccf] hover:bg-[#6c4ccf] hover:text-white transition">
            Login
          </button>

          <button
          onClick={() => setOpenModal(true)}
           className="h-[38px] px-[18px] font-poppins rounded-[10px] bg-[#6c4ccf] text-white">
            Book a meeting
          </button>
        </div>
      </div>

      {/* ================= MOBILE MENU ================= */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="flex flex-col items-center gap-[18px] py-[20px] border-t bg-white">

          <NavLink
            to="/"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              isActive ? "text-[#6c4ccf] font-medium" : ""
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/Ourproject"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              isActive ? "text-[#6c4ccf] font-medium" : ""
            }
          >
            Our projects
          </NavLink>

          <NavLink
            to="/testimonials"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              isActive ? "text-[#6c4ccf] font-medium" : ""
            }
          >
            Testimonials
          </NavLink>

          <NavLink
            to="/cost"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              isActive ? "text-[#6c4ccf] font-medium" : ""
            }
          >
            Cost estimator
          </NavLink>

          <NavLink
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) =>
              isActive ? "text-[#6c4ccf] font-medium" : ""
            }
          >
            Contacts
          </NavLink>

          <button
          onClick={() => setOpenModal(true)}
           className="w-[200px] h-[38px] rounded-[10px] bg-[#6c4ccf] text-white">
            Book a meeting
          </button>
        </div>
      </div>

      {/* ================= CITY MODAL ================= */}
      <CityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
      />
<BookMeetingModal
  openModal={openModal}
  setOpenModal={setOpenModal}
/>
    </header>
  );
}